import { OrbitControls } from '@react-three/drei';
import { ControlContext } from 'provider/ControlProvider';
import { useContext, useEffect, useRef } from 'react';
import { mapSizeX, citySize, initIndex } from 'constant/env';
import gsap from 'gsap';

export default function Controls() {
  const { currentIndex, navIndex } = useContext(ControlContext);
  const controlsRef = useRef<any>(null);
  const CameraMove = () => {
    gsap.to(controlsRef.current, {
      onStart: () => {
        controlsRef.current.minDistance = 4;
      },
      duration: 1,
      ease: 'power1',
      maxDistance: window.innerWidth >= 1024 ? 7 : 12,
      onComplete: () => {
        controlsRef.current.maxDistance = 40;
      },
    });
    gsap.to(controlsRef.current.target, {
      duration: 1,
      ease: 'power2.out',
      x: (currentIndex % mapSizeX) * citySize,
      y: 0,
      z: Math.floor(currentIndex / mapSizeX) * citySize,
    });
  };
  const CameraInit = () => {
    gsap.to(controlsRef.current, {
      onStart: () => {
        controlsRef.current.maxDistance = 80;
      },
      duration: 1,
      ease: 'power1',
      minDistance: 50,
      onComplete: () => {
        controlsRef.current.minDistance = 4;
      },
    });
  };
  useEffect(() => {
    if (currentIndex > -1 && navIndex === 2) CameraMove();
  }, [currentIndex]);
  useEffect(() => {
    if (navIndex === 0 && currentIndex > -1) CameraInit();
  }, [navIndex]);
  return (
    <group>
      <OrbitControls
        ref={controlsRef}
        autoRotate={false}
        minDistance={50}
        maxDistance={80}
        minAzimuthAngle={-Math.PI}
        maxAzimuthAngle={Math.PI}
        maxPolarAngle={Math.PI / 2}
        target={[
          (initIndex % mapSizeX) * citySize,
          0,
          Math.floor(initIndex / mapSizeX) * citySize,
        ]}
        position={[
          (initIndex % mapSizeX) * citySize,
          100,
          Math.floor(initIndex / mapSizeX) * citySize,
        ]}
      />
    </group>
  );
}
